// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../scalars/Scalars.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var AgentMarketingProfilePhotoForm = require("./AgentMarketingProfilePhotoForm.bs.js");
var AgentMarketingProfileFeaturedPortraitForm = require("./AgentMarketingProfileFeaturedPortraitForm.bs.js");
var AgentMarketingProfilePhotosSettingsQuery_graphql = require("../../__generated__/AgentMarketingProfilePhotosSettingsQuery_graphql.bs.js");

function AgentMarketingProfilePhotosSettings$Header(props) {
  var displayName = MarketingProfileSubpages.Page.Agent.useDisplayName();
  var breadcrumbs = [
    {
      name: "Marketing Profile",
      href: "/account/marketing_profile"
    },
    {
      name: displayName("Photos"),
      href: MarketingProfileSubpages.Page.Agent.path("Photos")
    }
  ];
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(Breadcrumbs.make, {
                      pages: breadcrumbs
                    }),
                JsxRuntime.jsx("h2", {
                      children: displayName("Photos"),
                      className: "text-zinc-800 text-3xl font-medium"
                    })
              ],
              className: "space-y-3"
            });
}

var Header = {
  make: AgentMarketingProfilePhotosSettings$Header
};

var convertVariables = AgentMarketingProfilePhotosSettingsQuery_graphql.Internal.convertVariables;

var convertResponse = AgentMarketingProfilePhotosSettingsQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = AgentMarketingProfilePhotosSettingsQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, AgentMarketingProfilePhotosSettingsQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function AgentMarketingProfilePhotosSettings(props) {
  var match = use(undefined, undefined, undefined, undefined);
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  var marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "AgentMarketingProfile") {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(AgentMarketingProfilePhotosSettings$Header, {}),
                                className: "pb-2"
                              }),
                          JsxRuntime.jsx(AgentMarketingProfilePhotoForm.make, {
                                marketingProfile: marketingProfile.fragmentRefs
                              }),
                          (function (__x) {
                                return ReactRender.ifTrue(JsxRuntime.jsx(AgentMarketingProfileFeaturedPortraitForm.make, {
                                                marketingProfile: marketingProfile.fragmentRefs
                                              }), __x);
                              })(hasFullProfile)
                        ],
                        className: "space-y-8 sm:space-y-0 divide-y divide-zinc-200"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              href: Scalars.$$URL.toString(marketingProfile.publicUrl),
                              target: "_blank",
                              children: "View Profile"
                            }),
                        className: "flex justify-between border-t border-zinc-200 pt-4"
                      })
                ],
                className: "bg-white p-6 shadow-sm rounded space-y-8"
              });
  } else {
    return UnselectedUnionMemberError.raise("Unselected union member: " + marketingProfile._0);
  }
}

var make = AgentMarketingProfilePhotosSettings;

exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
